import { createHook, createStore } from "react-sweet-state";
var StateDefaults = {
    dances: [],
};
var currentId = 0;
var createItem = function (name) {
    return { id: ++currentId, name: name };
};
var setDances = function (dances) { return function (store) {
    store.setState(function (draft) {
        draft.dances = dances.length == 0 ? [createItem('')] : dances.slice().map(function (x) { return createItem(x); });
    });
}; };
var insertDance = function (index) { return function (store) {
    store.setState(function (draft) {
        draft.dances.splice(index, 0, createItem(''));
    });
}; };
var addDance = function () { return function (store) {
    store.setState(function (draft) {
        draft.dances.push(createItem(''));
    });
}; };
var removeDance = function (index) { return function (store) {
    store.setState(function (draft) {
        if (draft.dances.length > 1) {
            draft.dances.splice(index, 1);
        }
    });
}; };
var moveUp = function (index) { return function (store) {
    store.setState(function (draft) {
        if (index == 0) {
            return;
        }
        var item = draft.dances[index];
        draft.dances.splice(index, 1);
        draft.dances.splice(index - 1, 0, item);
    });
}; };
var moveDown = function (index) { return function (store) {
    store.setState(function (draft) {
        if (index >= draft.dances.length - 1) {
            return;
        }
        var item = draft.dances[index];
        draft.dances.splice(index, 1);
        draft.dances.splice(index + 1, 0, item);
    });
}; };
var setDanceName = function (index, name) { return function (store) {
    store.setState(function (draft) {
        draft.dances[index].name = name;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        insertDance: insertDance,
        addDance: addDance,
        removeDance: removeDance,
        moveUp: moveUp,
        moveDown: moveDown,
        setDanceName: setDanceName,
        setDances: setDances,
    },
    name: "EventsPlanningCompetitionDancesEdit"
});
var useState = createHook(store);
export { useState as useEventsPlanningCompetitionDancesEdit, };
